import Link from "next/link";
import { useState } from "react";

// ─── Slide data ───────────────────────────────────────────────────────────────
const slide = {
  key: "medicine-abroad",
  slideClass: "slide-three",
  image: "/assets/img/ug_abroad/abroad1.svg",
  alt: "study medicine",
  heading: "Study Medicine Abroad",
  highlightPrefix: "At low Cost in",
  highlightSpan: "World Ranked Universities!",
  highlightSpanClass: "",
  highlightPillClass: "",
  subtitle: "Honest Counseling | University Selection | Admission",
  cta: "Register Now",
  ctaHref: "/mbbs-abroad#compare",
  colClass: "col-flag-3",
  countries: [
    { name: "Georgia", slug: "/mbbs-in-georgia", code: "ge" },
    { name: "Russia", slug: "/mbbs-in-russia", code: "ru" },
    { name: "Uzbekistan", slug: "/mbbs-in-uzbekistan", code: "uz" },
    { name: "Malaysia", slug: "/mbbs-in-malaysia", code: "my" },
    { name: "Nepal", slug: "/mbbs-in-nepal", code: "np" },
  ],
};

// ─── Dial codes ───────────────────────────────────────────────────────────────
const dialCodes = [
  { label: "Select", value: "" },
  { label: "IN (91)", value: "91" },
  { label: "AF (93)", value: "93" },
  { label: "AL (355)", value: "355" },
  { label: "AU (61)", value: "61" },
  { label: "AT (43)", value: "43" },
  { label: "BE (32)", value: "32" },
  { label: "BR (55)", value: "55" },
  { label: "CA (1)", value: "1" },
  { label: "CN (86)", value: "86" },
  { label: "HR (385)", value: "385" },
  { label: "CY (357)", value: "357" },
  { label: "CZ (420)", value: "420" },
  { label: "DK (45)", value: "45" },
  { label: "EE (372)", value: "372" },
  { label: "FI (358)", value: "358" },
  { label: "FR (33)", value: "33" },
  { label: "DE (49)", value: "49" },
  { label: "GE (995)", value: "995" },
  { label: "GR (30)", value: "30" },
  { label: "HU (36)", value: "36" },
  { label: "ID (62)", value: "62" },
  { label: "IE (353)", value: "353" },
  { label: "IL (972)", value: "972" },
  { label: "IT (39)", value: "39" },
  { label: "JP (81)", value: "81" },
  { label: "KZ (77)", value: "77" },
  { label: "LV (371)", value: "371" },
  { label: "LT (370)", value: "370" },
  { label: "LU (352)", value: "352" },
  { label: "MY (60)", value: "60" },
  { label: "MT (356)", value: "356" },
  { label: "MX (52)", value: "52" },
  { label: "NL (31)", value: "31" },
  { label: "NZ (64)", value: "64" },
  { label: "NG (234)", value: "234" },
  { label: "NO (47)", value: "47" },
  { label: "PK (92)", value: "92" },
  { label: "PL (48)", value: "48" },
  { label: "PT (351)", value: "351" },
  { label: "RO (40)", value: "40" },
  { label: "RU (7)", value: "7" },
  { label: "RS (381)", value: "381" },
  { label: "SG (65)", value: "65" },
  { label: "SK (421)", value: "421" },
  { label: "SI (386)", value: "386" },
  { label: "ZA (27)", value: "27" },
  { label: "ES (34)", value: "34" },
  { label: "LK (94)", value: "94" },
  { label: "SE (46)", value: "46" },
  { label: "CH (41)", value: "41" },
  { label: "TW (886)", value: "886" },
  { label: "TR (90)", value: "90" },
  { label: "AE (971)", value: "971" },
  { label: "GB (44)", value: "44" },
  { label: "US (1)", value: "1" },
  { label: "VN (84)", value: "84" },
];

// ─── Flag component ───────────────────────────────────────────────────────────
const CountryFlag = ({ code, name }) => (
  <div className="countries-flag">
    <img
      src={`https://flagcdn.com/w80/${code}.png`}
      srcSet={`https://flagcdn.com/w160/${code}.png 2x`}
      alt={name}
      loading="lazy"
    />
  </div>
);

// MBBS abroad countries (shared with header) — used for enquiry select
const mbbsCountries = [
  { name: 'China', value: 'china' },
  { name: 'Vietnam', value: 'vietnam' },
  { name: 'Philippines', value: 'philippines' },
  { name: 'New Zealand', value: 'new-zealand' },
  { name: 'Bangladesh', value: 'bangladesh' },
  { name: 'Kazakhstan', value: 'kazakhstan' },
  { name: 'Kyrgyzstan', value: 'kyrgyzstan' },
  { name: 'United States', value: 'usa' },
  { name: 'United Kingdom', value: 'uk' },
  { name: 'UAE', value: 'uae' },
  { name: 'Luxembourg', value: 'luxembourg' },
  { name: 'Japan', value: 'japan' },
  { name: 'Germany', value: 'germany' },
  { name: 'Netherlands', value: 'netherlands' },
  { name: 'Ireland', value: 'ireland' },
  { name: 'Belarus', value: 'belarus' },
  { name: 'Australia', value: 'australia' },
  { name: 'Canada', value: 'canada' },
  { name: 'Russia', value: 'russia' },
  { name: 'Georgia', value: 'georgia' },
  { name: 'Uzbekistan', value: 'uzbekistan' },
  { name: 'Malaysia', value: 'malaysia' },
  { name: 'Nepal', value: 'nepal' }
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function HeroSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    dialCode: "91",
    phone: "",
    program: "MBBS",
    country: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const apiBase = process.env.NEXT_PUBLIC_ADMIN_URL || "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const normalizeMobile = (phone, dialCode) => {
    const digitsOnly = phone.replace(/\D/g, "");
    const code = String(dialCode || "").replace(/\D/g, "");

    if (code && digitsOnly.startsWith(code)) {
      return digitsOnly.slice(code.length);
    }

    return digitsOnly;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.phone || !form.country) {
      setMessage("Please fill all required fields.");
      return;
    }

    setSubmitting(true);
    setMessage("");

    try {
      const [firstName, ...lastNameParts] = form.name.trim().split(/\s+/);
      const payload = {
        name: form.name.trim(),
        firstName: firstName || "",
        lastName: lastNameParts.join(" "),
        email: form.email.trim(),
        mobile: normalizeMobile(form.phone, form.dialCode),
        dialCode: form.dialCode,
        program: form.program,
        country: form.country,
        leadSource: "mbbs-abroad",
      };

      const response = await fetch(`${apiBase}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to submit lead");
      }

      setMessage("Thanks! We received your enquiry.");
      setForm({
        name: "",
        email: "",
        dialCode: "91",
        phone: "",
        program: "MBBS",
        country: "",
      });
    } catch (error) {
      console.error("Lead submit error:", error);
      setMessage("Submission failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <style>{`

        .banner-sec {
          position: relative;
          overflow: visible;
          margin-top: 88px;
        }

        .picsum-img-wrapper {
          position: relative;
          width: 100%;
          overflow: hidden;
          border-radius: 0;
          background: #e8f6ef;
        }

        .picsum-img-wrapper > figure {
          margin: 0;
          line-height: 0;
        }

        .picsum-img-wrapper > figure img {
          width: 100%;
          height: clamp(500px, 54vw, 620px);
          object-fit: cover;
          object-position: left center;
          display: block;
        }

        .picsum-img-content {
          position: absolute;
          top: 50%;
          right: clamp(430px, 32vw, 520px);
          left: auto;
          transform: translateY(-50%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          width: clamp(360px, 34vw, 520px);
          max-width: 520px;
          padding: 0;
          z-index: 2;
          gap: 0;
          text-align: left;
        }

        .picsum-img-content h2 {
          font-size: clamp(2rem, 3vw, 3.15rem);
          font-weight: 900;
          text-transform: uppercase;
          color: #ffffff;
          line-height: 1.05;
          margin: 0 0 12px 0;
          letter-spacing: -0.3px;
          text-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
        }

        .round-shape {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: transparent;
          border: 0;
          border-radius: 999px;
          padding: 0;
          font-size: clamp(1.08rem, 1.4vw, 1.95rem);
          font-weight: 700;
          color: #ffffff;
          white-space: nowrap;
          width: fit-content;
          margin-bottom: 0;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
        }

        .round-shape .text-blue {
          color: #ffffff;
        }

        .round-shape.solid-orange-- {
          color: #ffffff;
        }

        .picsum-img-content h3 {
          font-size: clamp(0.92rem, 1.25vw, 1.18rem);
          font-weight: 600;
          color: #ffffff;
          margin: 12px 0 18px 0;
          line-height: 1.5;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
        }

        .flags-grid {
          display: grid;
          grid-template-columns: repeat(3, 78px);
          gap: 12px 12px;
          margin: 0 0 18px 0;
          justify-content: start;
          align-items: start;
        }

        .col-flag-3 {
          grid-template-columns: repeat(3, 78px);
        }

        .col-flag-4 {
          grid-template-columns: repeat(4, 78px);
        }

        .flags-grid a {
          width: 78px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
        }

        .flags-grid figure {
          width: 78px;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-align: center;
        }

        .flags-grid figcaption {
          width: 100%;
          display: block;
          text-align: center;
          font-size: 0.88rem;
          font-weight: 600;
          line-height: 1.2;
          color: #ffffff;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
        }

        .countries-flag {
          width: 72px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #d9e1ea;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          background: #f8fafc;
          transition: transform 0.16s ease, box-shadow 0.16s ease;
        }

        .flags-grid a:hover .countries-flag {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 4px 12px rgba(0,0,0,0.14);
        }

        .countries-flag img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .bullet-list {
          list-style: none;
          padding: 0;
          margin: 0 0 14px 0;
        }

        .bullet-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 0.88rem;
          font-weight: 600;
          color: #0f172a;
          margin-bottom: 9px;
          line-height: 1.4;
        }

        .mk-check {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: #f97316;
          color: #fff;
          font-size: 0.85rem;
          flex-shrink: 0;
          font-style: normal;
        }

        .btn-outline-solid {
          display: inline-flex;
          align-items: center;
          border: 2px solid #185fb7;
          background: #ffffff;
          color: #185fb7;
          font-size: 0.92rem;
          font-weight: 700;
          border-radius: 12px;
          padding: 12px 22px;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.2s ease;
          line-height: 1;
          box-shadow: 0 2px 8px rgba(24, 95, 183, 0.12);
        }

        .btn-outline-solid:hover {
          background: #ffffff;
          color: #1e5fad;
          border-color: #1e5fad;
          box-shadow: 0 6px 16px rgba(24, 95, 183, 0.18);
          transform: translateY(-2px);
        }

        .btn-outline-solid .mk-arrow-right {
          display: inline-block;
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1.5px solid rgba(24,95,183,0.3);
          font-style: normal;
          font-size: 1rem;
        }

        .btn-outline-solid.mt-2 {
          margin-top: 8px;
        }

        .enqiry-form {
          position: absolute;
          top: 50%;
          right: clamp(18px, 3.6%, 56px);
          transform: translateY(-50%);
          z-index: 30;
          width: clamp(320px, 26vw, 382px);
          background: #ffffff;
          border-radius: 18px;
          box-shadow:
            0 2px 4px rgba(15,23,42,0.06),
            0 10px 40px rgba(15,23,42,0.14);
          padding: 28px 24px 24px 24px;
        }

        .form-heading {
          font-size: 1.14rem;
          font-weight: 700;
          color: #ff9245;
          margin: 0 0 18px 0;
          line-height: 1.35;
        }

        .form-control,
        .form-select {
          display: block;
          width: 100%;
          height: 46px;
          border: 1.5px solid #d6dce5;
          border-radius: 11px;
          padding: 0 14px;
          font-size: 0.9rem;
          color: #3a4048;
          background: #fff;
          outline: none;
          box-sizing: border-box;
          transition: border-color 0.15s, box-shadow 0.15s;
          -webkit-appearance: auto;
          appearance: auto;
        }

        .form-control::placeholder {
          color: #94a3b8;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #2d6cdf;
          box-shadow: 0 0 0 3px rgba(45,108,223,0.11);
        }

        .form-group {
          margin-bottom: 12px;
        }

        .form-group:last-child {
          margin-bottom: 0;
        }

        .newSelectInput {
          display: grid;
          grid-template-columns: 108px 1fr;
          gap: 10px;
        }

        .newSelectInput .form-select,
        .newSelectInput .form-control {
          width: 100%;
        }

        .btnSubmit {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          width: 100%;
          height: 50px;
          margin-top: 6px;
          background: #ff9245;
          color: #fff;
          border: none;
          border-radius: 12px;
          font-size: 0.98rem;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.01em;
          box-shadow: 0 8px 24px rgba(216,12,12,0.26);
          transition: background 0.17s, box-shadow 0.17s, transform 0.1s;
        }

        .btnSubmit:hover {
          background: #bf0909;
          box-shadow: 0 10px 28px rgba(216,12,12,0.34);
        }

        .btnSubmit:active {
          transform: scale(0.98);
        }

        .btnSubmit .mk-arrow-right {
          display: inline-block;
          padding-left: 10px;
          border-left: 1.5px solid rgba(255,255,255,0.35);
          font-style: normal;
          font-size: 1rem;
        }

        @media (max-width: 1024px) {
          .banner-sec {
            margin-top: 78px;
          }

          .enqiry-form {
            width: clamp(270px, 30vw, 320px);
            padding: 20px 18px;
          }

          .picsum-img-content {
            right: clamp(330px, 34vw, 360px);
            width: clamp(300px, 34vw, 420px);
            max-width: 420px;
            padding: 0;
          }

          .flags-grid {
            gap: 10px 12px;
          }

          .col-flag-3 {
            grid-template-columns: repeat(3, 64px);
          }

          .col-flag-4 {
            grid-template-columns: repeat(4, 64px);
          }

          .flags-grid a,
          .flags-grid figure {
            width: 64px;
          }

          .countries-flag {
            width: 60px;
            height: 40px;
          }

          .flags-grid figcaption {
            font-size: 0.78rem;
          }
        }

        @media (max-width: 820px) {
          .banner-sec {
            margin-top: 64px;
          }

          /* Stack the enquiry form under the hero on small screens (include 768px) */
          .enqiry-form {
            display: block;
            position: static;
            top: auto;
            right: auto;
            transform: none;
            z-index: 3;
            width: 100%;
            max-width: 540px;
            margin: 18px auto 0;
            border-radius: 12px;
            padding: 18px;
            box-shadow: 0 6px 18px rgba(15,23,42,0.08);
          }

          .picsum-img-content {
            top: 50%;
            left: clamp(12px, 3.5vw, 20px);
            right: auto;
            transform: translateY(-50%);
            width: 90%;
            max-width: 90%;
            padding: 0 6px;
          }

          .picsum-img-wrapper > figure img {
            height: clamp(320px, 70vw, 440px);
          }

          /* Make flags horizontally scrollable to avoid wrapping issues */
          .flags-grid {
            display: flex;
            gap: 8px 8px;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 6px;
            align-items: center;
          }

          .col-flag-3 {
            grid-template-columns: repeat(3, 58px);
          }

          .col-flag-4 {
            grid-template-columns: repeat(4, 50px);
          }

          .flags-grid {
            display: flex;
            gap: 6px;
            overflow-x: auto;
            justify-content: center;
            padding-bottom: 8px;
            -webkit-overflow-scrolling: touch;
          }
            width: 54px;
            height: 36px;
          }

          .flags-grid figcaption {
            font-size: 0.72rem;
            white-space: nowrap;
          }

          .picsum-img-content h2 {
            font-size: clamp(1.35rem, 5vw, 1.95rem);
          }

          .picsum-img-content h3 {
            font-size: clamp(0.82rem, 2.8vw, 0.98rem);
          }

          .btn-outline-solid {
            padding: 10px 18px;
          }

          /* Reduce arrow divider on small buttons */
          .btn-outline-solid .mk-arrow-right {
            padding-left: 8px;
            border-left: none;
          }
        }

        @media (max-width: 600px) {
          /* Tighten flag gaps, sizes and make flags scrollable */
          .flags-grid {
            display: flex;
            gap: 6px;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 6px;
            align-items: center;
            justify-content: flex-start;
          }

          .col-flag-3 {
            grid-template-columns: repeat(3, 52px);
          }

          .col-flag-4 {
            grid-template-columns: repeat(4, 48px);
          }

          .flags-grid a,
          .flags-grid figure {
            width: 52px;
          }

          .countries-flag {
            width: 48px;
            height: 32px;
            border-radius: 6px;
          }

          .flags-grid figcaption {
            font-size: 0.68rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .picsum-img-content h2 {
            font-size: clamp(1.2rem, 4.2vw, 1.8rem);
          }

          .picsum-img-content h3 {
            font-size: clamp(0.78rem, 2.6vw, 0.92rem);
          }

          .enqiry-form {
            padding: 16px;
            border-radius: 10px;
            width: calc(100% - 32px);
            max-width: 520px;
            margin: 12px auto 0;
          }
        }

        @media (max-width: 480px) {
          .col-flag-4 {
            grid-template-columns: repeat(4, 42px);
            gap: 6px;
          }

          .countries-flag {
            width: 42px;
            height: 28px;
            border-radius: 4px;
          }
        }

        .bannerSwiper .swiper-pagination {
          bottom: 14px;
        }
      `}</style>

      <section className="banner-sec p-0">
        <div className="desktop-banner--">
          <div className={`picsum-img-wrapper ${slide.slideClass}`}>
            <figure className="mb-0">
              <img
                src={slide.image}
                alt={slide.alt}
                width={1912}
                height={697}
                fetchPriority="high"
                loading="eager"
                decoding="sync"
                className="w-100 img-fluid"
              />
            </figure>

            <div className="picsum-img-content">
              <h2>{slide.heading}</h2>

              <div className={`round-shape ${slide.highlightPillClass || ""}`}>
                {slide.highlightPrefix}{" "}
                {slide.highlightSpan && (
                  <span className={slide.highlightSpanClass || ""}>
                    {slide.highlightSpan}
                  </span>
                )}
              </div>

              <h3>{slide.subtitle}</h3>

              {slide.countries && (
                <div className={`flags-grid ${slide.colClass}`}>
                  {slide.countries.map((c) => (
                    <Link key={c.name} href={c.slug}>
                      <figure>
                        <CountryFlag code={c.code} name={c.name} />
                        <figcaption>{c.name}</figcaption>
                      </figure>
                    </Link>
                  ))}
                </div>
              )}

              {/* <Link
                href={slide.ctaHref}
                className="btn btn-outline-solid btn-outline-tertery"
              >
                <span>{slide.cta}</span>
                <i className="mk-arrow-right">→</i>
              </Link> */}
            </div>
          </div>
        </div>

        <div className="enqiry-form">
          <h4 className="form-heading text-center">Get one on one free counselling</h4>
          <form noValidate className="space-y-4" onSubmit={handleSubmit}>

            {/* Name */}
            <div className="form-group">
              <input
                type="text"
                placeholder="Enter Your Name*"
                maxLength={60}
                className="form-control txtName w-full"
                name="name"
                value={form.name}
                onChange={handleChange}
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter Your EmailID*"
                maxLength={60}
                className="form-control txtEmail w-full"
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            {/* Phone */}
            <div className="form-group">
              <div className="newSelectInput flex items-center overflow-hidden rounded-lg border border-gray-300">

                <select
                  aria-label="Dial code"
                  className="form-select h-[48px] min-w-[90px] border-0 border-r border-gray-300 bg-white px-2 text-sm outline-none"
                  name="dialCode"
                  value={form.dialCode}
                  onChange={handleChange}
                >
                  {dialCodes.map((d, i) => (
                    <option key={i} value={d.value}>
                      {d.label}
                    </option>
                  ))}
                </select>

                <input
                  type="tel"
                  placeholder="Enter Contact No.*"
                  className="form-control txtMobile flex-1 border-0 shadow-none focus:ring-0"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Program */}
            <div className="form-group">
              <select
                className="form-select form-control w-full"
                name="program"
                value={form.program}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Program*
                </option>

                <option value="MBBS">MBBS</option>
              </select>
            </div>

            {/* Country */}
            <div className="form-group">
              <select
                className="form-select form-control w-full"
                name="country"
                value={form.country}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select MBBS Abroad Country*
                </option>

                {mbbsCountries.map((c, i) => (
                  <option key={i} value={c.value}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Button */}
            <div className="form-group pt-1">
              <button
                type="submit"
                className="btnSubmit flex w-full items-center justify-center gap-2"
                disabled={submitting}
              >
                <span>{submitting ? "Submitting..." : "Book Free Counselling"}</span>
                <i className="mk-arrow-right">→</i>
              </button>
            </div>
            {message && (
              <p style={{ marginTop: 8, fontSize: 12, color: "#475569" }}>{message}</p>
            )}
          </form>
        </div>
      </section>
    </>
  );
}
